export default __webpack_public_path__ + "media/images/Logo-ISQ.OPQCM-80-1517ed2f8ec281caf570a05623d3f77f.png";